import { render } from "./InvoiceSymbolsInput.vue?vue&type=template&id=276dcc08"
import script from "./InvoiceSymbolsInput.vue?vue&type=script&lang=js"
export * from "./InvoiceSymbolsInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__